import React, { Component, createRef } from 'react';
import HierarchyFieldSelectorPreview from './HierarchyFieldSelectorPreview.jsx';
import HierarchyFieldSelectorItem from './HierarchyFieldSelectorItem.jsx';

class HierarchyFieldSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: [1],
      values: [],
      value: this.getValue(),
    };
    this.levelRefs = {};
    props.definitions.forEach((i) => {
      this.levelRefs[i.level] = createRef();
    });
  }

  getValue() {
    if (typeof this.props.value !== 'undefined') {
      return this.props.value === null ? '' : this.props.value;
    }
    return '';
  }

  componentDidMount() {
    const currentLevel = this.state.value;

    if (currentLevel !== '') {
      this.setInitialState(currentLevel);
    } else {
      this.levelRefs[1].current.loadData(null);
    }
  }

  setInitialState(currentLevel) {
    let lastLevel, parentId;

    $.getJSON(`/${currentCustomer}/hierarchy_fields/${currentLevel}.json`).done(
      (data) => {
        const opened = [...this.state.opened];
        const values = [...this.state.values];
        const loads = [];
        Object.entries(data).forEach(([i, item]) => {
          lastLevel = parseInt(i);
          opened.push(lastLevel);
          values[lastLevel] = { label: item.name, value: item.id };
          parentId = item.parent_id;
          loads.push({ level: i, parent: parentId, value: item.id });
        });
        if (lastLevel < this.props.definitions.length) {
          opened.push(lastLevel + 1);
          loads.push({ level: lastLevel + 1, parent: values[lastLevel].value });
        }
        this.setState(
          {
            opened: _.uniq(opened),
            values: values,
          },
          () => {
            loads.forEach((l) => {
              this.levelRefs[l.level].current.loadData(l.parent, l.value);
            });
          },
        );
      },
    );
  }

  closeLevelsBelow(level, callback) {
    const opened = _.uniq([...this.state.opened, level]).filter(
      (i) => i <= level,
    );
    this.setState({ opened: opened }, () => {
      this.setShadowFieldValue();
      if (callback) {
        callback();
      }
    });
  }

  handleLevelChange(node, level) {
    let levelToOpen;

    if (this.props.onChange) {
      this.props.onChange(node, level.level);
    }

    this.updateValues(node, level.level);
    if (node !== null) {
      levelToOpen = level.level + 1;
      this.closeLevelsBelow(levelToOpen, () => {
        if (levelToOpen <= this.props.definitions.length) {
          this.levelRefs[levelToOpen].current.loadData(node.value);
        }
      });
    } else {
      this.closeLevelsBelow(level.level);
    }
  }

  updateValues(node, level) {
    let values;
    if (node === null) {
      values =
        level === 1
          ? []
          : _.reject(this.state.values, (_item, i) => i >= level);
    } else {
      values = [...this.state.values];
      values[level] = node;
      values = _.reject(values, (_item, i) => i > level);
    }
    this.setState({ values: values });
  }

  setShadowFieldValue() {
    const { values, opened } = this.state;
    const newValue =
      values.length > 0 ? (values[opened.length - 1]?.value ?? '') : '';

    this.setState({ value: newValue });
  }

  render() {
    return (
      <div className='HierchyNodeSelectorContainer'>
        <If condition={typeof this.props.name !== 'undefined'}>
          <input
            name={this.props.name}
            type='hidden'
            value={this.state.value}
          />
        </If>
        <HierarchyFieldSelectorPreview
          opened={this.state.opened}
          values={this.state.values}
        />
        <div className='HierarchyFieldSelectorForms hide-disabled'>
          {' '}
          {this.props.definitions
            .sort((a, b) => a.level - b.level)
            .map((i) => {
              return (
                <HierarchyFieldSelectorItem
                  key={i.id}
                  ref={this.levelRefs[i.level]}
                  data={i}
                  handleLevelChange={this.handleLevelChange.bind(this)}
                  opened={this.state.opened}
                />
              );
            })}{' '}
        </div>
      </div>
    );
  }
}

module.exports = HierarchyFieldSelector;
